<template>
  <div class="animated fadeIn">
    <b-container fluid class="pt-3 pr-3 pb-0 pl-3">
      <b-row>
        <!-- left -->
        <b-col>
          <b-card class="border-0">
            <div class="card-text pb-0">
              <div class="d-flex flex-row justify-content-start">
                <div class="text-dark mr-3"><i class="el-icon-location"></i></div>
                <div class="h4 font-weight-bold text-dark">Oversigt</div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <!-- aftaler -->
        <b-col sm="12" md="6" lg="12">
          <b-card-group>
            <!-- <b-card border-variant="light" class="pb-4 mr-4">
              <div class="h5 pt-0 pr-4 pb-2 pl-0 font-weight-bold">Aftaler</div>
              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center border-0 pl-0">
                  Fremsendte møder i alt
                  <b-badge variant="dark" pill><span class="font-weight-bold">{{ i1 }}</span></b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center border-0 pl-0">
                  Kommende møder
                  <b-badge variant="success" pill><span class="font-weight-bold">{{ i2 }}</span></b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center border-0 pl-0">
                  Aflyste møder
                  <b-badge variant="danger" pill><span class="font-weight-bold">{{ i3 }}</span></b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center border-0 pl-0">
                  Møder i alt (afholdte / til afholdelse)
                  <b-badge variant="info" pill><span class="font-weight-bold">{{ i3 }}</span></b-badge>
                </b-list-group-item>
              </b-list-group>
            </b-card> -->
            <!-- <b-card border-variant="light" class="pb-4">
              <div class="h5 pt-0 pr-4 pb-2 pl-0 font-weight-bold">Balance</div>
              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center border-0 pl-0">
                  Antal aflyste i alt
                  <b-badge variant="dark" pill>{{ i6 }}</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center border-0 pl-0">
                  Tildelt gratis
                  <b-badge variant="success" pill>{{ i7 }}</b-badge>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center border-0 pl-0">
                  Gratis møde til gode
                  <b-badge variant="danger" pill>{{ i8 }}</b-badge>
                </b-list-group-item>
              </b-list-group>
            </b-card> -->
          </b-card-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card border-variant="light">
            <div class="h5 pl-0 font-weight-bold">Kontakt- og firmaoplysninger</div>
            <!-- profiloplysninger -->
            <div class="">
              <!-- <profileinformation :res="res"></profileinformation> -->
            </div>
          </b-card>
        </b-col>
        <!-- right -->
        <b-col lg="3" md="4" sm="12">
          <!-- kundehenvendelser -->
          <!-- <kundemodal></kundemodal> -->
          <!-- archived -->
          <!-- <archivemodal></archivemodal> -->
          <!-- hotline -->
          <!-- <hotlinemodal></hotlinemodal> -->
          <!-- råd og vejledning -->
          <!-- <textvejledning></textvejledning> -->
          <!-- change creditcard -->
          <!-- <textcreditcard></textcreditcard> -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import kundemap from './KundeMap'
// import marketplace from './Marketplace'
// import marketarchive from './MarketArchive'
// import oversigt from './Oversigt'
import cancellations from './CancellationsTable'
// import profileinformation from './ProfileInformation'
import textvejledning from './textVejledning'
import hotlinemodal from './modals/HotlineModal'
import archivemodal from './modals/ArchiveModal'
import kundemodal from './modals/KundeModal'
import profilesetup from './ProfileSetup'
import textcreditcard from './textCreditcard'
export default {
  name: 'mainpage',
  components: {
    // oversigt,
    kundemap,
    cancellations,
    // profileinformation,
    textvejledning,
    hotlinemodal,
    kundemodal,
    archivemodal,
    profilesetup,
    textcreditcard
  },
  created () {
    this.Reload()
  },
  data () {
    return {
      text: '',
      i1: '',
      i2: '',
      i3: '',
      i6: '',
      i7: '',
      i8: '',
      res: [],
      form: {
        message: ''
      }
    }
  },
  methods: {
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'oversigt_partner', salesPerson: this.salesPerson, typeMeeting: '1'}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.i1 = res['1']
            this.i2 = res['2']
            this.i3 = res['3']
            this.i6 = res['6']
            this.i7 = res['7']
            this.i8 = res['8']
          },
          response => {
            alert('error')
          }
        )
      var dataPartner = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1'}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.res = res
          },
          response => {
            alert('error')
          }
        )
    }
  }
}
</script>
<style scoped>
.table thead th,
.table th,
.table td {
  border-bottom: 0;
  border-top: 0;
}
textarea.form-control {
  background: rgba(236, 240, 241,1.0);
  border-radius: 3px;
  border: 0;
}
.modal-footer,
.modal-header {
  border-bottom: 0;
  border-top: 0;
}
</style>


// WEBPACK FOOTER //
// MainPage.vue?431e215e